import click from '@mailobj-browser/front/js/events/types/click.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import preventDefault
  from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import {
  onClick as onClickAnchor
} from '#components/generics/js/tabs/anchor.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { elements } from '#components/generics/js/styles.js'
import * as utilities from '#utilities/js/styles.js'
import * as lightbox from '#utilities/js/lightboxes/lightbox.js'

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: (
    button
  ) => {
    let container = closest(`.${elements.tabs}`, button)

    if (!container) {
      const { ownerDocument } = button
      const dropdown = one(`.${elements.dropdown}`, ownerDocument)
      const opener = lightbox.opener(dropdown)
      container = closest(`.${elements.tabs}`, opener)
    }

    const tabSelected = one(`.${elements.tab_panel}:not(.${utilities.modifiers.display.none})`, container)

    if (tabSelected) {
      const itemsChecked = all(`input[type='checkbox']:checked:not([disabled])`, tabSelected)
      const itemsIndeterminate = all(`input[type='checkbox']:indeterminate:not([disabled])`, tabSelected)

      if (itemsChecked) {
        for (const itemSelected of itemsChecked) {
          itemSelected.checked = false
        }
      }

      if (itemsIndeterminate) {
        for (const itemSelected of itemsIndeterminate) {
          itemSelected.indeterminate = false
        }
      }
    }

    onClickAnchor.task(button)
  }
})

export default button => {
  onClick.listen(button)
}
